import React from 'react';
import { Box, useTheme } from '@mui/material';
import { useReducedMotion } from 'framer-motion';
import { keyframes } from '@emotion/react';

const blob1 = keyframes`
  0%, 100% { transform: translate(0,0) scale(1); }
  33%       { transform: translate(60px,-40px) scale(1.1); }
  66%       { transform: translate(-30px,50px) scale(0.95); }
`;
const blob2 = keyframes`
  0%, 100% { transform: translate(0,0) scale(1); }
  33%       { transform: translate(-50px,60px) scale(1.05); }
  66%       { transform: translate(70px,-30px) scale(1.1); }
`;
const blob3 = keyframes`
  0%, 100% { transform: translate(0,0) scale(1); }
  33%       { transform: translate(40px,40px) scale(0.9); }
  66%       { transform: translate(-60px,-50px) scale(1.1); }
`;

/**
 * Fixed full-viewport radial-gradient blobs that animate slowly behind the admin shell.
 * Static in reduced-motion mode.
 */
export default function AnimatedBackground() {
  const reducedMotion = useReducedMotion();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const shared = {
    position: 'fixed',
    borderRadius: '50%',
    filter: 'blur(80px)',
    opacity: isDark ? 0.18 : 0.06,
    pointerEvents: 'none',
    zIndex: 0,
  };

  return (
    <Box
      aria-hidden="true"
      sx={{
        position: 'fixed',
        inset: 0,
        overflow: 'hidden',
        zIndex: 0,
        pointerEvents: 'none',
      }}
    >
      {/* Indigo blob — top-left */}
      <Box
        sx={{
          ...shared,
          width: 600,
          height: 600,
          top: '-120px',
          left: '-100px',
          background: 'radial-gradient(circle, #6366F1 0%, transparent 70%)',
          animation: reducedMotion ? 'none' : `${blob1} 24s ease-in-out infinite`,
        }}
      />
      {/* Violet blob — bottom-right */}
      <Box
        sx={{
          ...shared,
          width: 700,
          height: 700,
          bottom: '-150px',
          right: '-150px',
          background: 'radial-gradient(circle, #8B5CF6 0%, transparent 70%)',
          animation: reducedMotion ? 'none' : `${blob2} 30s ease-in-out infinite`,
        }}
      />
      {/* Cyan blob — top-right */}
      <Box
        sx={{
          ...shared,
          width: 500,
          height: 500,
          top: '20%',
          right: '10%',
          background: 'radial-gradient(circle, #22D3EE 0%, transparent 70%)',
          animation: reducedMotion ? 'none' : `${blob3} 20s ease-in-out infinite`,
        }}
      />
    </Box>
  );
}
